module.exports = __webpack_public_path__ + "static/enjoyTheSilence-37df3000b483f9f8eeb3de9cf8555c51.jpg";